import { render, staticRenderFns } from "./people-seleter.vue?vue&type=template&id=4c6a9746&scoped=true&"
import script from "./people-seleter.vue?vue&type=script&lang=js&"
export * from "./people-seleter.vue?vue&type=script&lang=js&"
import style0 from "./people-seleter.vue?vue&type=style&index=0&id=4c6a9746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6a9746",
  null
  
)

export default component.exports